import React, { FC, useCallback } from 'react';
import { observer } from "mobx-react-lite";
import "../../styles/checkbox.css";

interface ICheckbox {
    id: number;
    handleSelection: (id: number, e: React.ChangeEvent<HTMLInputElement>, nameForFilter?: string, roleId?: number) => void;
    nameForFilter?: string;
    checked?: boolean;
    roleId?: number;
    color?: string;
}

const Checkbox: FC<ICheckbox> = observer(({
    id,
    handleSelection,
    nameForFilter,
    checked,
    roleId,
    color

}) => {
    const handleCheck = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        handleSelection(id, e, nameForFilter, roleId);
    }, [id, handleSelection, nameForFilter, roleId]);

    return (
        <label className={`custom-checkbox ${color || ''}`}>
            <input
                checked={checked}
                onChange={handleCheck}
                type="checkbox"
                aria-checked={checked}
            />
            <span></span>
        </label>
    );
});

export default Checkbox;